﻿<div class="route-component">
    <div class="form-component">
        <h4 *ngIf="batchId === 0">
            Create Matching Batch
        </h4>

        <form #form="ngForm" (ngSubmit)="onSave(form)">

            <div class="input-group">
                <auto-complete-dropdown
                    [options]="periods"
                    [label]="'Period'"
                    [placeholder]="'Select a period...'"
                    [initialValue]="selectedPeriodId"
                    [required]="true"
                    [invalid]="!selectedPeriodId"
                    [validationMessage]="'Period is required'"
                    [displayWith]="displayPeriod"
                    (selectionChange)="onPeriodSelectionChange($event)">
                </auto-complete-dropdown>
            </div>

            <div class="input-group">
                <auto-complete-dropdown
                    [options]="clients"
                    [label]="'Client'"
                    [placeholder]="'Select a client...'"
                    [initialValue]="selectedClientId"
                    [required]="true"
                    [invalid]="!selectedClientId"
                    [validationMessage]="'Client is required'"
                    (selectionChange)="onClientSelectionChange($event)">
                </auto-complete-dropdown>
            </div>

            <div class="input-group" *ngIf="clientAreas.length > 0">
                <auto-complete-dropdown
                    [options]="clientAreas"
                    [label]="'Client Policy'"
                    [placeholder]="'Select a client policy...'"
                    [initialValue]="selectedClientAreaId"
                    [required]="true"
                    [invalid]="!selectedClientAreaId && formSubmitted"
                    [validationMessage]="'Client Policy is required'"
                    [displayWith]="displayClientArea"
                    (selectionChange)="onClientAreaSelectionChange($event)">
                </auto-complete-dropdown>
            </div>

            <div class="action-bar">
                <button type="submit" class="button"
                    [disabled]="
                    !selectedPeriodId ||
                    !selectedClientId ||
                    form.invalid || isSaving">
                    <span *ngIf="isSaving" class="loading-spinner"></span>
                    <i *ngIf="!isSaving" class="fas fa-save"></i>
                        Save
                </button>
                <button type="button" class="button-cancel" (click)="onCancel()">
                    <i class="fas fa-cancel"></i> Cancel
                </button>
            </div>
        </form>
    </div>
</div>